<template>
    <v-textarea
        outlined
        hide-details
        v-bind="$attrs"
        v-on="$listeners"/>
</template>

<script>
export default {
    name: 'TextArea'
}
</script>

<style lang="scss" scoped>
</style>
